// stack — default skin module
// NO external imports — plain JavaScript only

const GAP_TOKENS = {
  none: '0',
  xs:   'var(--run-space-semantic-xs, 4px)',
  sm:   'var(--run-space-semantic-sm, 8px)',
  md:   'var(--run-space-semantic-md, 16px)',
  lg:   'var(--run-space-semantic-lg, 24px)',
  xl:   'var(--run-space-semantic-xl, 32px)',
};

const JUSTIFY_MAP = {
  start:   'flex-start',
  center:  'center',
  end:     'flex-end',
  between: 'space-between',
  around:  'space-around',
  evenly:  'space-evenly',
};

const ALIGN_MAP = {
  start:    'flex-start',
  center:   'center',
  end:      'flex-end',
  stretch:  'stretch',
  baseline: 'baseline',
};

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
`;

export function render(host) {
  const { gap, direction, align, justify, wrap } = host;

  const flexDirection = direction === 'horizontal' ? 'row' : 'column';
  const flexWrap      = wrap ? 'wrap' : 'nowrap';
  const alignItems    = ALIGN_MAP[align]   || 'stretch';
  const justifyContent = JUSTIFY_MAP[justify] || 'flex-start';
  const gapValue      = GAP_TOKENS[gap] || gap || 'var(--run-stack-gap, var(--run-space-semantic-md, 16px))';

  host.shadowRoot.innerHTML = `
    <div part="base" style="
      display: flex;
      flex-direction: ${flexDirection};
      flex-wrap: ${flexWrap};
      align-items: ${alignItems};
      justify-content: ${justifyContent};
      gap: ${gapValue};
      box-sizing: border-box;
      width: 100%;
    "><slot></slot></div>
  `;
}
